const AccountRoute = {
  path: 'account',
  component: () => import("@/components/BasicRouter.vue"),
  name: 'Meus Dados',
  meta: {
    spacingTop: true
  },
  children: [
    {
      path: '',
      component: () => import("@/views/account/AccountPage.vue"),
    },
    {
      path: 'password',
      component: () => import("@/views/account/PasswordPage.vue"),
    }
  ]
}

export default AccountRoute;
